// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import PriceFillController from "./price_fill_controller"
application.register("price-fill", PriceFillController)

import WarehouseOperationController from "./warehouse_operation_controller"
application.register("warehouse-operation", WarehouseOperationController)
